import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketManager, useTicketData } from "../../..";
import { ColumnContext } from "../../context/ColumnContext";
import { KanbanContext } from "../../context/KanbanContext";
import { TicketCard } from "./TicketCard";
import { TicketListItem } from "./TicketListItem";

export const TicketTileKanban = observer(
  (props: { ticketManager: TicketManager }) => {
    const ticketData = useTicketData();
    const columnId = React.useContext(ColumnContext);
    const kanbanManager = React.useContext(KanbanContext);
    const { setNodeRef, transform, isDragging, listeners, attributes } =
      useDraggable({
        id: columnId + "-" + ticketData.ticket.id,
        data: { ticketData: ticketData, origin: columnId },
      });

    return (
      <div
        {...attributes}
        ref={setNodeRef}
        style={{
          transform: CSS.Translate.toString(transform),
          zIndex: isDragging ? 100 : "",
          position: isDragging ? "relative" : "static",
        }}
      >
        {kanbanManager.viewType === "column" && (
          <TicketCard
            ticketManager={props.ticketManager}
            listeners={listeners}
            isDragging={isDragging}
          />
        )}

        {kanbanManager.viewType === "list" && (
          <TicketListItem
            ticketManager={props.ticketManager}
            listeners={listeners}
            isDragging={isDragging}
          />
        )}
      </div>
    );
  }
);
